"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestTimeoutError = exports.InvalidMethodError = exports.OrderOfOperationsError = exports.ResponseParseError = exports.RequestSyntaxError = exports.InternalServerError = exports.MultipleMatchesError = exports.EntityNotFoundError = exports.UnauthorizedError = exports.UnauthenticatedError = exports.ValidationError = void 0;
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "ValidationError";
        return _this;
    }
    return ValidationError;
}(Error));
exports.ValidationError = ValidationError;
var UnauthenticatedError = /** @class */ (function (_super) {
    __extends(UnauthenticatedError, _super);
    function UnauthenticatedError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Authentication failed. Try Chariot.refreshLogin({ refresh_token }).") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "UnauthenticatedError";
        return _this;
    }
    return UnauthenticatedError;
}(Error));
exports.UnauthenticatedError = UnauthenticatedError;
var UnauthorizedError = /** @class */ (function (_super) {
    __extends(UnauthorizedError, _super);
    function UnauthorizedError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Authorization failed. The logged-in user may not have access to make this request.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "UnauthorizedError";
        return _this;
    }
    return UnauthorizedError;
}(Error));
exports.UnauthorizedError = UnauthorizedError;
var EntityNotFoundError = /** @class */ (function (_super) {
    __extends(EntityNotFoundError, _super);
    function EntityNotFoundError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "The Entity you requested was not found on the server.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "EntityNotFoundError";
        return _this;
    }
    return EntityNotFoundError;
}(Error));
exports.EntityNotFoundError = EntityNotFoundError;
var MultipleMatchesError = /** @class */ (function (_super) {
    __extends(MultipleMatchesError, _super);
    function MultipleMatchesError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Multiple entities were returned for the provided paramters, when only one was expected.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "MultipleMatchesError";
        return _this;
    }
    return MultipleMatchesError;
}(Error));
exports.MultipleMatchesError = MultipleMatchesError;
var InternalServerError = /** @class */ (function (_super) {
    __extends(InternalServerError, _super);
    function InternalServerError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "An error occurred on the server while processing the request.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "InternalServerError";
        return _this;
    }
    return InternalServerError;
}(Error));
exports.InternalServerError = InternalServerError;
var RequestSyntaxError = /** @class */ (function (_super) {
    __extends(RequestSyntaxError, _super);
    function RequestSyntaxError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "An error occurred while parsing the syntax of the request.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "ResponseParseError";
        return _this;
    }
    return RequestSyntaxError;
}(Error));
exports.RequestSyntaxError = RequestSyntaxError;
var ResponseParseError = /** @class */ (function (_super) {
    __extends(ResponseParseError, _super);
    function ResponseParseError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "An error occurred while parsing the response from the server.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "ResponseParseError";
        return _this;
    }
    return ResponseParseError;
}(Error));
exports.ResponseParseError = ResponseParseError;
var OrderOfOperationsError = /** @class */ (function (_super) {
    __extends(OrderOfOperationsError, _super);
    function OrderOfOperationsError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Attempted to execute library methods in an improper order.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "OrderOfOperationsError";
        return _this;
    }
    return OrderOfOperationsError;
}(Error));
exports.OrderOfOperationsError = OrderOfOperationsError;
var InvalidMethodError = /** @class */ (function (_super) {
    __extends(InvalidMethodError, _super);
    function InvalidMethodError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Attempted to execute a library method that is unavailable or invalid.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "InvalidMethodError";
        return _this;
    }
    return InvalidMethodError;
}(Error));
exports.InvalidMethodError = InvalidMethodError;
var RequestTimeoutError = /** @class */ (function (_super) {
    __extends(RequestTimeoutError, _super);
    function RequestTimeoutError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || "Request time exceeded the deadline.") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "RequestTimeoutError";
        return _this;
    }
    return RequestTimeoutError;
}(Error));
exports.RequestTimeoutError = RequestTimeoutError;
